import { EditorJson, EditorJsonProps } from '../../EditorJson';
import { FormFieldProps } from '../types';
import { splitProps } from '@/utils';
import { Field, useField } from '../Field';
import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const EditorJsonComponent = (props: EditorJsonProps) => {
  const { setValue } = useFormContext();
  const field = useField();
  const { value, name } = field;

  const onChange = useCallback(
    (value: string) => {
      setValue(name, value, { shouldDirty: true, shouldValidate: true });
    },
    [setValue, name],
  );

  useEffect(() => {
    if (!value) {
      setValue(name, '{}', { shouldDirty: false, shouldTouch: false, shouldValidate: false });
    }
  }, [value, name, setValue]);

  return <EditorJson {...{ ...props, ...field, onChange }} />;
};

export const EditorJsonField = (fieldProps: FormFieldProps<EditorJsonProps>) => {
  const restProps = splitProps(fieldProps, ['className', 'disabled']) as EditorJsonProps;

  return (
    <Field {...fieldProps}>
      <EditorJsonComponent {...restProps} />
    </Field>
  );
};
